import React from "react";
import "./ElectionInput.scss";
import CalendarPickerInput from "./CalendarPickerInput";
import DropdownInput from "./DropdownInput";

const ElectionInput = ({
  isRequired = false,
  placeholder = "Unesite tekst",
  isDateTime = false,
  isDate = false,
  isDropdown = false,
  onChange,
  name, // IMPORTANT, SHOULD NOT BE EMPTY
  value,
  disabled = false,
  setCalendar,
  calendar,
  dropdownOptions,
  dropdownType,
  dispatch,
}) => {
  let inputParametars = {
    placeholder: "_placeholder",
    className: disabled ? "election-input-txt input-field-disabled" : "election-input-txt",
    type: "text",
    name: name,
    onChange: onChange,
    value: value,
    disabled: disabled,
  };

  if (name === "numberOfChoices") {
    inputParametars.min = "1";
    inputParametars.max = "30";
    inputParametars.type = "number";
  }

  if (isDate || isDateTime) {
    // String -> date conversion
    if (calendar) {
      if (calendar === "0001-01-01T00:00:00" || calendar === "1970-01-01T01:00:00.000") {
        calendar = "";
      } else {
        calendar = new Date(calendar);
      }
    }

    return (
      <CalendarPickerInput
        name={name}
        setCalendar={setCalendar}
        calendar={calendar}
        isDateOnly={isDate ? true : false}
        isRequired={isRequired}
        disabled={disabled}
        placeholder={placeholder}
      />
    );
  }

  if (isDropdown) {
    return (
      <DropdownInput
        options={dropdownOptions}
        name={name}
        onChange={onChange}
        value={value}
        disabled={disabled}
        dropdownType={dropdownType}
        dispatch={dispatch}
        isRequired={isRequired}
      />
    );
  }

  return (
    <div className="floating-label-wrap">
      <input {...inputParametars} />
      <label className="election-input-label is-size-4" typeof="text" htmlFor="input1">
        {placeholder}
        {isRequired ? <span className="has-text-danger ml-1">*</span> : ""}
      </label>
    </div>
  );
};

export default ElectionInput;
